import React, { FC } from 'react'
import * as R from 'ramda'
import { inject } from 'mobx-react'
import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { getHreflangByI18nKey } from 'components/DocumentHead/helpers'
import { getCanonicalFromHreflangs } from 'helpers/seo'
import { IStoreProvider } from 'store'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default R.compose(
  inject((store: IStoreProvider) => {
    const { originByLocaleMap, translatedUrlsPerLocale } = store.urlManagerStore
    const { locale } = store.localeStore
    const links = getHreflangByI18nKey({
      key: 'dein-shop_url',
      originByLocaleMap,
      translatedUrlsPerLocale,
      excludeLocales: store.featureStore.getDisabledExpansionLocales(),
    })
    const canonicalUrl = getCanonicalFromHreflangs({ hreflangs: links, locale })
    return {
      renderHreflangs: true,
      links,
      canonicalUrl,
    }
  }),
)(DocumentHead)
